import { createAuthClient } from 'better-auth/react';
import { adminClient } from 'better-auth/client/plugins';
import { buildApiUrl } from '../services/apiUrl.js';

export function getAuthClientBaseUrl(): string {
  return buildApiUrl('/api/auth');
}

export function getAuthClientFetchOptions(): { credentials: 'include' } {
  return {
    credentials: 'include',
  };
}

export const authClient = createAuthClient({
  baseURL: getAuthClientBaseUrl(),
  fetchOptions: getAuthClientFetchOptions(),
  plugins: [adminClient()],
});
